<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="page-box-title title1">作文重写</div>
            <div>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-input v-model="rewriteText" type="textarea" :rows="6" placeholder="请输入作文文本，文本拍照二选一即可"></el-input>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-upload class="upload-box" v-model:file-list="fileList" action="#" :max="5" list-type="picture-card" :http-request="httpRequest" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                            <div class="upload-inner">
                                <div>
                                    <el-icon size="24">
                                        <Camera />
                                    </el-icon>
                                </div>
                                <div>作文上传</div>
                            </div>
                        </el-upload>
                    </el-col>
                </el-row>
                <div class="correct-tip">
                    <span class="activeColor">*提示：</span>
                    <span>一次拍一页，可多次拍摄，最多可拍摄5页</span>
                </div>
            </div>
            <div style="margin:20px 0;">
                <el-button :disabled="aiStart" style="width:100%" color="#ef8b25" class="footer-btn1" @click="rewriteClick">AI作文批改</el-button>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="page-box-title2 title1">重写作文批改结果</div>
            <div class="page-inner-box parseBox" v-if="Object.keys(resultInfo).length">
                <template v-if="resultInfo.Ⅰ && resultInfo.Ⅰ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅰ" :key="'rⅠ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
                <template v-if="resultInfo.Ⅱ && resultInfo.Ⅱ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅱ" :key="'rⅡ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
                <template v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅲ" :key="'rⅢ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
                <template v-if="resultInfo.Ⅳ && resultInfo.Ⅳ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅳ" :key="'rⅣ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
                <template v-if="resultInfo.Ⅴ && resultInfo.Ⅴ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅴ" :key="'rⅤ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
                <template v-if="resultInfo.Ⅵ && resultInfo.Ⅵ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅵ" :key="'rⅥ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
            </div>
            <div v-html="aiMessage" class="page-inner-box" v-if="!Object.keys(resultInfo).length && aiMessage && aiMessage!='{}'">

            </div>
            <div class="page-inner-box empty" v-if="!Object.keys(resultInfo).length && !aiMessage">
                <img src="@/assets/img/empty.png" />
                <div>结果将在此处展示！</div>
            </div>
        </div>

        <el-image-viewer v-if="showPreview" :url-list="previewFileArr" show-progress :initial-index="previewIndex" @close="showPreview = false" />
        <AIpopup v-if="popupShow" :popupShow="popupShow" :cancelShow="false" @cancel="aiCancel"></AIpopup>
    </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compRewiredEvalStreamingV2, saveSreamResult, checkAiCall } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import { useRoute } from 'vue-router';
import { useStore } from "vuex"
const store = useStore();
const route = useRoute()
const rewriteText = ref('')
const artiCorrectingId = ref('')

const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
const aiStart = ref(false)
const popupShow = ref(false)
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function rewriteClick() {
    if (!rewriteText.value && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}

function getAi() {
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        text: rewriteText.value || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
        artiCorrectingId: artiCorrectingId.value || ''
    }
    aiStart.value = true
    popupShow.value = true
    fetchRequest({
        url: compRewiredEvalStreamingV2,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
    // compRewiredEvalStreaming(params).then(res => {
    //     fetchRequest(res.data)
    // }).catch(() => {
    //     aiStart.value = false
    //     popupShow.value = false
    // })
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    const { signal } = controller;
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                if (line.indexOf('Done') > -1) {
                    isMessage = false;
                    aiStart.value = false
                }
                if (line.indexOf('Error') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (line.indexOf('"500"') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    let errorMsg = JSON.parse(line).msg;
                    return ElMessage.warning(errorMsg || 'AI调用失败，请稍后再试！');
                }
                if (isMessage && line.indexOf('content') > -1) {
                    let jsonString = '';
                    if (line.startsWith('data:')) {
                        jsonString = line.substring(5).trim();
                    } else {
                        jsonString = line
                    }

                    if (jsonString) {
                        try {
                            const jsonData = JSON.parse(jsonString)
                            if (jsonData ?.node_type == 'End') {
                                console.log('node_is_finish')
                                return
                            }
                            const content = (jsonData ?.content || '');
                            if (content) {
                                str += content
                                const matches = content.match(regex) || [];
                                let resultArr = matches.filter(match => match !== '');
                                resultArr.forEach(info => {
                                    if (romanNumerals.includes(info)) {
                                        if (info in resultNum) {
                                            resultNum[info] = resultNum[info] + 1;
                                            resultInfo.value[info].push('');
                                        } else {
                                            resultNum[info] = 1;
                                            resultInfo.value[info] = [''];
                                        }
                                        currentKey = info;
                                    } else if (currentKey in resultInfo.value) {
                                        if (resultNum[currentKey] == 1) {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                        } else {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                        }

                                    }
                                })
                                console.log(resultInfo.value)
                                aiMessage.value = str
                            }
                        } catch (error) {
                            console.log(error)
                            aiStart.value = false
                            return ElMessage.warning('AI调用失败，请稍后再试！');
                        }
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}

onBeforeUnmount(() => {
    controller && controller.abort()
})


onMounted(() => {
    artiCorrectingId.value = route.query.artiCorrectingId || '';
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.correct-title {
    font-size: 12px;
    color: $base-text-color;
    line-height: 1.8;
    margin: 20px 0;
}

.correct-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}
</style>
